import ApiService from "@/core/services/api.service";

// action types
export const ORDERS = "business/sales/orders";
export  const DASHBOARD_DATA="business/sales/dasboard-data"
export const INVOICE = "business/sales/orders/invoice";
export const CHANGE_STATUS = "business/sales/change-status";
export const GENERATE_LINK= "business/sales/send-payment-link";
export const UPDATE_LOADING ='updateLoading';

// mutation types
export const SET_ORDERS = "setOrders";
export const SET_ERROR = "setError";
export const SET_LOADING="setLoading";
export const SET_PAGINATION="setPagination";
const state = {
  orders: [],
  errors: null,
  loading:true,
};

const getters = {
  getOrders(state) {
    return state.orders;
  },
  getLoading(state){
    return state.loading
  }
};

const actions = {
  [INVOICE](context, form) {
    return new Promise(resolve => {
      ApiService.get(INVOICE , form)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR, response.data.errors);
          });
    });
  },
[ORDERS](context, params) {
  return new Promise((resolve, reject) => {
    context.commit(SET_LOADING, true);
    
    // Build URL safely
    const baseUrl = ORDERS.startsWith('/') ? ORDERS : `/${ORDERS}`;
    const queryString = new URLSearchParams(params).toString();
    const url = `${baseUrl}?${queryString}`;
    
    ApiService.post(url)
      .then(response => {
        if (!response.data) {
          throw new Error('Invalid response structure');
        }

            console.log('ssss')
        context.commit(SET_ORDERS, response.data.data);
         context.commit(SET_LOADING, false);
     
        context.commit(SET_PAGINATION, {
          currentPage: response.data.pagination.current_page,
          perPage: response.data.pagination.per_page,
          total: response.data.pagination.total,
          lastPage: response.data.pagination.last_page
        });
       
        resolve(response.data);
      })
      .catch(error => {
        const errorMessage = error.response?.data?.message || 
                           error.message || 
                           'Failed to fetch orders';
        console.error('API Error:', {
          url,
          status: error.response?.status,
          error: error.response?.data || error.message
        });
        reject(new Error(errorMessage));
      })
      .finally(() => {
        context.commit(SET_LOADING, false);
      });
  });
},
[DASHBOARD_DATA](context, params) {
  return new Promise((resolve, reject) => {
   // context.commit(SET_LOADING, true);
    
    ApiService.get('business/sales/dasboard-data', params)  // Changed from DASHBOARD_DATA to 'dashboard'
      .then(({ data }) => {
        console.log('Vuex action response:', data.upcoming_orders);
        context.commit(SET_ORDERS, data.upcoming_orders); // Remove .data
        context.commit(SET_LOADING, false);
        resolve(data); // Resolve with the full response
      })
      .catch(error => {
        console.error('Vuex action error:', error);
        context.commit(SET_ERROR, error.response);
        reject(error);
      });
  });
},
  [CHANGE_STATUS](context, form) {
    return new Promise(resolve => {
      ApiService.post(CHANGE_STATUS , form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GENERATE_LINK](context, form) {
    return new Promise(resolve => {
      ApiService.post(GENERATE_LINK , form)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [UPDATE_LOADING](context,bool){
    context.commit(SET_LOADING,bool);
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ORDERS](state, obj) {
    state.orders = obj;
  },
[SET_LOADING](state,bool){
    state.loading=bool

  },
   [SET_PAGINATION](state, pagination) {
    state.pagination = {
      currentPage: pagination.current_page,
      perPage: pagination.per_page,
      total: pagination.total,
      lastPage: pagination.last_page
    };
  }
};

export default {
  state,
  actions,
  mutations,
  getters
}
